import { defineStore } from 'pinia';
import type { Cart } from '~/modules/checkout/types';

interface CustomerState {
  cart: Cart,
}

export const useCartStore = defineStore('cart', {
  state: (): CustomerState => ({
    cart: {
      id: '',
      is_virtual: false,
      total_quantity: 0,
      total_positions: 0,
      shipping_addresses: [],
    },
  }),
});
